import React from 'react'

import AddSignature from 'presentation/doctor/pages/AddSignature'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiRepository } from 'repository/api-repository'
import { DoctorRepository } from 'repository/repositories/doctor/doctor-repository'
import { RemoteAddDoctorSignature } from 'service/usecases/add-doctor-signature/remote-add-doctor-signature'

export default function makeDoctorAddSignature() {
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )

  const doctorRepository = new DoctorRepository(apiRepository)
  const addDoctorSignature = new RemoteAddDoctorSignature(doctorRepository)

  return <AddSignature addDoctorSignature={addDoctorSignature} />
}
